import styled from "styled-components";

export const TabReportsContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 94px;
    table{
        width: 1080px;
        border-collapse: collapse;

        .flex{
            display: flex;
            align-items: center;
            padding: 2px 0;
        }

        .image_inspector{
            width: 32px;
            height: 32px;
            border-radius: 9999px;
            overflow: hidden;
            margin-right: 8px;
        }

        
        th{
            border-bottom: 1px solid #A8A8A8;
            height: 40px;
            text-align: start;
        }
        tbody{
            font-weight: 500;
        }

        .check{
            text-align: start;
        }

        td{
            height: 32px;
            margin-bottom: 16px;
        }
    }
`;

export const TabReportsFilters = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px 0;
    gap: 24px;

    .search{
        width: 190px;
        height: 24.222px;
        background-color: #E6E4E0;
        padding: 4px 8px;
    }
`;